<table
	[attr.summary]="description"
	class="table table-hover"
	[class.c-table-fixed]="fixedLayout"
	[id]="id"
	[attr.data-cy]="'table-' + id"
>
	<ng-content></ng-content>
</table>
